'use client';

import { type FC, useMemo } from 'react';

import { ModalFloatingContext } from './context/modal-floating.context';
import { ModalRootContext } from './context/modal-root.context';
import { useModal } from './hooks/use-modal';
import type { ModalRootPropsInterface } from './types/modal-root.types';

/**
 * @since 10.0.0
 */
export const ModalRoot: FC<ModalRootPropsInterface> = (props: ModalRootPropsInterface) => {
  const { children, scrollDocument = false, size = 'xs', ...rest } = props;

  const { modal, floating } = useModal(rest);
  const contextValue = useMemo(
    () => ({ modal, scrollDocument, size }),
    [modal, scrollDocument, size],
  );
  return (
    <ModalRootContext.Provider value={contextValue}>
      <ModalFloatingContext.Provider value={floating}>{children}</ModalFloatingContext.Provider>
    </ModalRootContext.Provider>
  );
};

ModalRoot.displayName = 'Modal.Root';
